/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetStoresQuery } from '../../models/get-stores-query';
import { GetStoresQueryResult } from '../../models/get-stores-query-result';

export interface ApiNurseryManagerCategoryGetStoresPost$Params {
      body?: GetStoresQuery
}

export function apiNurseryManagerCategoryGetStoresPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerCategoryGetStoresPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStoresQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerCategoryGetStoresPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetStoresQueryResult>;
    })
  );
}

apiNurseryManagerCategoryGetStoresPost.PATH = '/api/NurseryManager/Category/GetStores';
